package com.essntl.features.invoice.data

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.invoice.data")
class InvoiceModule
